module.exports = __webpack_public_path__ + "static/media/icon-payment-tip-checked.b474c50c.svg";